export default __webpack_public_path__ + "static/google-play-badge-436ee702557f63504c25b1d63006e6b83c97a84c53ada5fa4270b81960a2035b.png";